import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/Home.vue'
import Feedback from '@/views/home/Feedback.vue'
import Updates from '@/views/home/Updates.vue'

var router = new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/home/feedback',
            name: 'feedback',
            component: Feedback,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/home/updates',
            name: 'updates',
            component: Updates,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '*',
            beforeEnter(route) { window.location.href = route.path }
        }
    ]
})

Vue.use(Router)
export default router
